import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Button from './Button';

const OpenModal = props => (
	<React.StrictMode>
		<div className="re-confirm-container">
			<div className="re-container-outer re-confirm-inner">
				<div className="re-confirm-title">{props.description}</div>
				<div className="re-confirm-buttons" id="re-confirm-buttons" tabIndex="0">
					{props.abortLabel && (
						<Button type="button" text={props.abortLabel} onClick={props.closeModal} className="re-btn re-btn-cancel" />
					)}
					{props.confirmLabel && (
						<Button type="button" text={props.confirmLabel} onClick={props.confirm} className="re-btn re-confirm" />
					)}
				</div>
			</div>
		</div>
	</React.StrictMode>
);

OpenModal.propTypes = {
	description: PropTypes.string,
	abortLabel: PropTypes.string,
	confirmLabel: PropTypes.string.isRequired,
	closeModal: PropTypes.func,
	confirm: PropTypes.func
};

const ConfirmAlert = props =>
	new Promise(resolve => {
		const promise = { resolve };
		const wrapper = document.body.appendChild(document.createElement('div'));
		wrapper.setAttribute('id', 'ConfirmAlert');

		const confirm = () => {
			props.closeModal();
			return promise.resolve(true);
		};

		const closeModal = () => {
			const thingToRemove = document.getElementById('ConfirmAlert');
			thingToRemove.parentNode.removeChild(thingToRemove);
		};

		Object.assign(props, { confirm: confirm, closeModal: closeModal });

		ReactDOM.render(<OpenModal {...props} />, wrapper);
		document.getElementById('re-confirm-buttons').focus();
	});

export default ConfirmAlert;
